import gql from '@js/api/utils/gql'

export const cartFragment = gql`
  fragment CartDetails on Cart {
    id
    email
    total_quantity
    coupon_details {
      code
      rule_name
      description
    }
    applied_store_credit {
      applied_balance {
        value
        currency
      }
      current_balance {
        value
        currency
      }
    }
    prices {
      grand_total {
        value
        currency
      }
      discount {
        label
        amount {
          value
          currency
        }
      }
      subtotal_excluding_tax {
        value
        currency
      }
      subtotal_including_tax {
        value
        currency
      }
    }
    items {
      uid
      prices {
        price {
          value
          currency
        }
      }
      product {
        name
        sku
      }
    }
  }
`
